import axios from 'axios'
import {apiUrl} from '@/api/base.js'

export default {
    get_symposium_user(lesson_id) {
        return axios.get(`${apiUrl}v2/symposium_user/${lesson_id}`)
    },
    get_symposium_info(lesson_id) {
        return axios.get(`${apiUrl}v2/symposium_info/${lesson_id}`)
    },
    get_symposium_subject(lesson_id) {
        return axios.get(`${apiUrl}v2/get_symposium_subject/${lesson_id}`)
    },
    get_symposium_current_page(lesson_id) {
        return axios.get(`${apiUrl}v2/get_symposium_current_page/${lesson_id}`)
    },
    set_symposium_current_page(args) {
        return axios.post(`${apiUrl}v2/set_symposium_current_page/`, {params: args})
    },
    add_page(args) {
        return axios.post(`${apiUrl}v2/add_page/`, {params: args})
    },
    open_symposium_socket(args) {
        return axios.post(`${apiUrl}v2/open_symposium_socket/`, {params: args})
    },
    get_up_message(page_id) {
        return axios.get(`${apiUrl}v2/get_up_message/${page_id}`)
    },
    support_up_message(message_id) {
        return axios.post(`${apiUrl}v2/support_up_message/${message_id}`)
    },
    stamp_up_message(message_id) {
        return axios.post(`${apiUrl}v2/stamp_up_message/${message_id}`)
    },
    delete_up_message(message_id) {
        return axios.post(`${apiUrl}v2/delete_up_message/${message_id}`)
    },
    get_is_socket_opened(lesson_id) {
        return axios.get(`${apiUrl}v2/get_is_socket_opened/${lesson_id}`)
    },
    post_img(file){
        return axios.post(`${apiUrl}v2/upload_file/`, {params: file}, {headers:{'Content-Type':'multipart/form-data'}})
    }
}
